import src from "IMAGE";
export default { src, width: 48, height: 48, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
